import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const HoldingsModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      height: "auto",
      borderRadius: "12px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      minWidth: "350px",
      overflowX: "auto",
      overflowY: "hidden",
      zIndex: 1,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      whiteSpace: "nowrap",
    },
    tableRow: {
      height: "80px",
      borderTop: "1px solid #EAEAEA",
    },
    tableHeadItem: {
      padding: "20px 20px",
    },
    tableBodyItem: {
      textAlign: "left",
      padding: "5px 0px",
    },
    tablecellItem: {
      color: "#000000",
    },
    code1: {
      fontWeight: 600,
      paddingLeft: "10px",
    },
    code2: {
      fontWeight: 600,
    },
  }),
);
